import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './Input.css';

const Input = ({ 
  type = 'text', 
  className = '', 
  ...props 
}) => {
  let theme = 'dark';
  try {
    const themeContext = useTheme();
    theme = themeContext.theme || 'dark';
  } catch (error) {
    // Fallback to dark theme if ThemeProvider is not available
    theme = 'dark';
  }
  
  const baseClasses = 'unified-input';
  const themeClass = theme === 'dark' ? 'unified-input-dark' : 'unified-input-light';
  const combinedClasses = `${baseClasses} ${themeClass} ${className}`.trim();

  return (
    <input
      type={type}
      className={combinedClasses}
      {...props}
    />
  );
};

export default Input;

